var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.3818 84.3062H25.7446C24.0615 84.3062 22.697 82.9417 22.697 81.2585V19.9351C22.697 15.449 26.3335 11.8125 30.8196 11.8125H87.8774C92.3635 11.8125 96 15.449 96 19.9351V77.688C96 81.3435 93.0374 84.3062 89.3818 84.3062Z",
    fill: "#EFD707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7446 84.3062H89.3818C93.0374 84.3062 96 81.3428 96 77.688V25.3088L89.6711 18.98C88.6377 17.8264 87.137 17.0999 85.4663 17.0999H23.2068C22.8779 17.9824 22.697 18.9375 22.697 19.9351V81.2585C22.697 82.9417 24.0615 84.3062 25.7446 84.3062V84.3062Z",
    fill: "url(#paint0_linear_1_21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1365 17.7429C27.2571 21.26 30.5244 23.6477 34.2158 23.6477H56.7202C56.4229 23.6477 56.1284 23.6309 55.8369 23.6001L46.7007 14.4697C45.1355 12.8276 42.9375 11.8381 40.5623 11.8381H30.9836C28.3945 11.8381 26.0771 13.0005 24.5222 14.8301C25.2327 15.6672 25.7886 16.6501 26.1365 17.7429Z",
    fill: "url(#paint1_linear_1_21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4663 84.3062H11.3071C8.18994 84.3062 5.66309 81.7793 5.66309 78.6621V22.7432C5.66309 19.626 8.18994 17.0991 11.3071 17.0991H85.4663C88.5835 17.0991 91.1104 19.626 91.1104 22.7432V78.6621C91.1104 81.7793 88.5835 84.3062 85.4663 84.3062Z",
    fill: "url(#paint2_linear_1_21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2559 26.3079C81.7104 24.6709 79.5212 23.6477 77.0918 23.6477H5.66309V78.6621C5.66309 81.7793 8.18994 84.3062 11.3071 84.3062H85.4663C88.5835 84.3062 91.1104 81.7793 91.1104 78.6621V34.1624L83.2559 26.3079Z",
    fill: "url(#paint3_linear_1_21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1365 17.7429C27.2571 21.26 30.5244 23.6477 34.2158 23.6477H56.7202C56.4229 23.6477 56.1284 23.6309 55.8369 23.6001L49.3323 17.0991H25.8999C25.9863 17.3101 26.0669 17.5232 26.1365 17.7429V17.7429Z",
    fill: "url(#paint4_linear_1_21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0328 25.7858V23.6479H56.3201C52.6294 23.6479 49.3621 21.2602 48.2415 17.7431C47.1209 14.226 43.8536 11.8383 40.1622 11.8383H30.5835C25.9012 11.8383 22.1043 15.6344 22.1043 20.3175V25.7858H57.0328Z",
    fill: "#FFE609"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1365 17.7429C25.0159 14.2258 21.7485 11.8381 18.0579 11.8381H8.47925C3.79614 11.8381 0 15.6343 0 20.3174V75.9324C0 80.5569 3.74927 84.3062 8.37378 84.3062H87.8862C86.6074 84.3062 85.571 83.2698 85.571 81.991V32.127C85.571 27.4446 81.7749 23.6477 77.0918 23.6477H34.2158C30.5244 23.6477 27.2571 21.26 26.1365 17.7429V17.7429Z",
    fill: "#FFE609"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_21",
    x1: 77.0523,
    y1: 71.6125,
    x2: 45.6362,
    y2: 40.1963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_21",
    x1: 52.9367,
    y1: 32.8729,
    x2: 28.5343,
    y2: 8.47044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_21",
    x1: 48.3866,
    y1: -6.80759,
    x2: 48.3866,
    y2: 85.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_21",
    x1: 90.5335,
    y1: 58.3506,
    x2: 66.6311,
    y2: 56.0911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#8190A4",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_21",
    x1: 52.6924,
    y1: 32.6286,
    x2: 30.4814,
    y2: 10.4176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.27
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderYellow);
export default __webpack_public_path__ + "static/media/folder-yellow.5c66a4bd.svg";
export { ForwardRef as ReactComponent };